import { useSelector } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';

const CONFIG = {
    success: {
        icon: (
            <svg className="w-3.5 h-3.5" viewBox="0 0 16 16" fill="currentColor">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>
        ),
        dot: 'bg-emerald-400',
        text: 'text-emerald-400',
    },
    error: {
        icon: (
            <svg className="w-3.5 h-3.5" viewBox="0 0 16 16" fill="currentColor">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
            </svg>
        ),
        dot: 'bg-red-400',
        text: 'text-red-400',
    },
    warning: {
        icon: (
            <svg className="w-3.5 h-3.5" viewBox="0 0 16 16" fill="currentColor">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L7.1 4.995z" />
            </svg>
        ),
        dot: 'bg-amber-400',
        text: 'text-amber-400',
    },
    info: {
        icon: (
            <svg className="w-3.5 h-3.5" viewBox="0 0 16 16" fill="currentColor">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
            </svg>
        ),
        dot: 'bg-blue-400',
        text: 'text-blue-400',
    },
};

export default function Toast() {
    const toast  = useSelector(s => s.toast);
    const config = CONFIG[toast.type] || CONFIG.info;

    return (
        <AnimatePresence>
            {toast.visible && (
                <motion.div
                    key="toast"
                    initial={{ opacity: 0, y: -20, scale: 0.9  }}
                    animate={{ opacity: 1, y: 0,   scale: 1    }}
                    exit={{    opacity: 0, y: -14,  scale: 0.92 }}
                    transition={{ type: 'spring', stiffness: 500, damping: 36 }}
                    className="fixed top-4 inset-x-0 z-[9999] pointer-events-none flex justify-center px-4"
                >
                    {/* iOS-style pill */}
                    <div className="flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-[#1c1c1e]/95 backdrop-blur-2xl shadow-[0_4px_24px_rgba(0,0,0,0.45)]">
                        {/* Colored icon */}
                        <span className={config.text}>
                            {config.icon}
                        </span>

                        {/* Message */}
                        <p className="text-[13px] font-semibold text-white/95 tracking-tight whitespace-nowrap">
                            {toast.message}
                        </p>

                        {/* Status dot */}
                        <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${config.dot}`} />
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
